import {ASSET_AVATARS} from "../../../utils/constants/paths";
import {getAssetPath} from "../../../utils/appHelpers";

export const users = [
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar3.jpg`,"72x72"),
        firstName: "Jannie",
        lastName: "Thompson",
        title: "Grenada",
        handle: "@jannie",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 243,
            views: 689,
            followers: 457
        },
        isFavorite: false,
        isOnline: true,
        isFollowing: true
    },
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar4.jpg`,"72x72"),
        firstName: "Eliza",
        lastName: "Shelton",
        title: "Marketing Head",
        handle: "@eliza",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 145,
            views: 650,
            followers: 401
        },
        isFavorite: true,
        isOnline: false,
        isFollowing: false
    },
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar5.jpg`,"72x72"),
        firstName: "Irene",
        lastName: "Owen",
        title: "Grenada",
        handle: "@irene",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 301,
            views: 1004,
            followers: 560
        },
        isFavorite: false,
        isOnline: true,
        isFollowing: true
    },
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar6.jpg`,"72x72"),
        firstName: "Rebeca",
        lastName: "Nunez",
        title: "Graphic Designer",
        handle: "@rebeca.graphic",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 37,
            views: 356,
            followers: 120
        },
        isFavorite: false,
        isOnline: true,
        isFollowing: false,
    },
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar7.jpg`,"72x72"),
        firstName: "Stacy",
        lastName: "Burns",
        title: "Creative Head",
        handle: "@stacy.burns",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 216,
            views: 435,
            followers: 250
        },
        isFavorite: true,
        isOnline: false,
        isFollowing: false,
    },
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar8.jpg`,"72x72"),
        firstName: "Daniel",
        lastName: "Murray",
        title: "Web Master",
        handle: "@web.daniel",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 243,
            views: 649,
            followers: 497
        },
        isFavorite: false,
        isOnline: false,
        isFollowing: false,
    },
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar9.jpg`,"72x72"),
        firstName: "Rocky",
        lastName: "Hamilton",
        title: "Marketing Head",
        handle: "@rocky.h",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 24,
            views: 69,
            followers: 4
        },
        isOnline: true,
        isFavorite: false,
        isFollowing: true
    },
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar10.jpg`,"72x72"),
        firstName: "Jack",
        lastName: "Brown",
        title: "Fashion Artist",
        handle: "@jack.brown",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 2,
            views: 6,
            followers: 4
        },
        isFavorite: false,
        isOnline: true,
        isFollowing: true,
    },
    {
        profilePic: getAssetPath(`${ASSET_AVATARS}/avatar11.jpg`,"72x72"),
        firstName: "Mariya",
        lastName: "Gray",
        title: "Human Resource",
        handle: "@mariya.human",
        socialLinks: {
            facebook: "#",
            twitter: "#",
            linkedIn: "#"
        },
        summary: {
            projects: 342,
            views: 986,
            followers: 754
        },
        isFavorite: true,
        isOnline: false,
        isFollowing: true,
    },
];
